import { render, staticRenderFns } from "./EmployeeForm.vue?vue&type=template&id=260c6360&scoped=true&"
import script from "./EmployeeForm.vue?vue&type=script&lang=ts&"
export * from "./EmployeeForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260c6360",
  null
  
)

export default component.exports